import {NOTIFICATION_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const SUPPORT_TEAM_PATH = 'supportTeams'

//#region Page
export function getPageSupportTeams(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${NOTIFICATION_ENDPOINT}/${SUPPORT_TEAM_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region List
export function getListSupportTeams(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${NOTIFICATION_ENDPOINT}/${SUPPORT_TEAM_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdateSupportTeam(userId, data) {
    return axiosInstance
        .post(
            `${NOTIFICATION_ENDPOINT}/${SUPPORT_TEAM_PATH}/createOrUpdate`,
            data,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Delete
export function deleteSupportTeam(userId, id) {
    return axiosInstance
        .delete(`${NOTIFICATION_ENDPOINT}/${SUPPORT_TEAM_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
